import AnnoPanel from '@/components/AnnoPanel.vue';
import * as api from '@/api/api.js';
import { taskTypeMap, disableAnnoTaskType, roleMapReverse, undeterminedClassId } from '@/config';
import { imageReformat } from '@/utils/util';

export default {
  name: 'ImageDetail',
  data: function() {
    return {
      imageId: 0,
      url: '',
      orgUrl: '',
      currOperation: 'point',
      taskType: null, // AnnoPanel中的标注类型
      taskTypeId: null, // 服务端返回的标注类型
      taskTypeMap: {},
      annotations: [],
      classifications: [],
      classes: [],
      annos: [],
      mode: 1,
      currAnno: {},
      currClasses: [],
      width: 0,
      height: 0,
      saveAnnoAble: false,
      orgAnnos: [],
      showPanel: true,
      sceneText: '',
      wordsIndex: 0,
      taskList: [],
      taskDetail: {},
      role: '',
      curPage: true,
      duoview: null,
      duoviewVisible: false,
    };
  },
  computed: {
    isTextType() {
      if (
        this.taskTypeId === 5 ||
        this.taskTypeId === 6 ||
        this.taskTypeName === '文本矩形' ||
        this.taskTypeName === '文本多边形'
      )
        return true;
      else return false;
    },
    annoEnable() {
      return this.taskTypeId !== disableAnnoTaskType || roleMapReverse[this.$store.state.role] === 1;
    },
  },
  components: {
    AnnoPanel,
  },
  watch: {
    classifications() {
      this.reformatClassification();
    },
    imageStatus() {
      this.reformatClassification();
    },
  },
  mounted: function() {
    if (this.pageType === 'amend') return;
    this.curPage = true;
    let _this = this;
    document.onkeydown = function() {
      let key = window.event.keyCode;
      if (key === 27) {
        _this.backToViewMode();
      } else if (key === 81) {
        _this.newAnno();
      } else if (key === 37 && _this.curPage) {
        _this.toPrev();
      } else if (key === 39 && _this.curPage) {
        _this.toNext();
      }
    };
    this.getNewImage();
    this.role = this.$store.state.role;
    this.getTaskDetail();
    this.taskTypeMap = taskTypeMap;
    if (this.pageType !== 'edit' && this.pageType !== 'saapprove') this.getClassInfo();
  },
  methods: {
    backToViewMode() {
      if (this.mode === 0) {
        this.mode = 1;
        this.currClasses = [];
        this.sceneText = '';
        this.annos = JSON.parse(JSON.stringify(this.orgAnnos));
      }
    },
    words() {
      this.currOperation = 'words';
      if (this.wordsIndex >= this.orgAnnos.length) this.wordsIndex = 0;
      this.currAnno = JSON.parse(JSON.stringify(this.orgAnnos[this.wordsIndex]));
      // window.console.log(JSON.parse(JSON.stringify(this.currAnno)));
      let x = this.currAnno.data[0][0][0];
      let y = this.currAnno.data[0][0][1];
      let w = this.currAnno.data[0][1][0] - this.currAnno.data[0][0][0];
      let h = this.currAnno.data[0][1][1] - this.currAnno.data[0][0][1];
      // 矩形框按理来说第一个点一定是左上 第二个点一定是右下
      this.url = `${this.orgUrl}?imageMogr2/crop/!${w}x${h}a${x}a${y}`;
      this.$refs.annopanel.setPainter(this.currAnno);
      this.currAnno.data = [
        [
          [0, 0],
          [w, h],
        ],
      ];
      this.annos = [this.currAnno];
      this.sceneText = this.currAnno.words;
      this.mode = 0;
    },
    nextAnno() {
      // this.saveAnno();
      this.annos = [];
      // window.console.log(this.wordsIndex);
      if (++this.wordsIndex < this.orgAnnos.length) this.words();
      else {
        alert('已到底');
        this.wordsIndex = 0;
        this.sceneText = '';
        this.mode = 1;
      }
    },
    point() {
      this.mode = 1;
      this.currOperation = 'point';
      this.sceneText = '';
      this.annos = JSON.parse(JSON.stringify(this.orgAnnos));
      this.url = this.orgUrl;
    },
    getDeleteName() {
      if (this.currOperation === 'words') return '回退';
      return this.$refs.annopanel && this.$refs.annopanel.getPainter().id ? '删除' : '取消';
    },
    compareAnno() {
      // 判断当前编辑的这个标注有没有改动过点和类别 改动过返回false
      if (this.currAnno.status === 2) return false;
      let matchAnno = this.orgAnnos.find(v => v.id === this.currAnno.id);
      if (JSON.stringify(this.currAnno.data) !== JSON.stringify(matchAnno.data)) return false;
      if (
        this.taskTypeId === 5 ||
        this.taskTypeId === 6 ||
        this.taskTypeName === '文本矩形' ||
        this.taskTypeName === '文本多边形'
      ) {
        if (this.sceneText === matchAnno.words) return true;
      } else {
        if (JSON.stringify(this.currAnno.classIds) === JSON.stringify(matchAnno.classIds)) return true;
      }
      return false;
    },
    getClassInfo() {
      this.taskId = this.$route.query.tid ? this.$route.query.tid : this.$route.query.taskid;
      if (this.taskId || this.$route.params.id) {
        api
          .getClassInfo(this.taskId ? this.taskId : this.$route.params.id)
          // .getClassInfo(this.taskId ? this.taskId : this.$route.query.tid)
          .then(res => {
            this.classifications = res.data.classifications;
            this.classes = this.classifications
              .reduce((total, item) => [...total, ...item.classes], [])
              .reduce((total, item) => {
                total[item.classId] = item.className;
                return total;
              }, {});
          })
          .catch(() => {});
      } else {
        api.getClassesByTaskList({ tid: this.taskList.map(v => v.taskId).join(',') }).then(res => {
          this.classifications = res.data.classifications;
          this.classes = this.classifications
            .reduce((total, item) => [...total, ...item.classes], [])
            .reduce((total, item) => {
              total[item.classId] = item.className;
              return total;
            }, {});
        });
      }
    },
    //
    annosFormat() {
      this.orgAnnos = this.annotations.map(anno => {
        let tmpAnno = {
          id: anno.id,
          type: this.taskTypeMap[this.taskTypeId || anno.taskTypeId],
          data: anno.points,
          userId: anno.userId,
          status: anno.status,
        };
        if (
          this.taskTypeId !== 5 &&
          this.taskTypeName !== '文本矩形' &&
          this.taskTypeId !== 6 &&
          this.taskTypeName !== '文本多边形'
        ) {
          tmpAnno.cat = anno.classes[0].classId;
          tmpAnno.title = anno.classes.map(item => item.className).join(',');
          tmpAnno.classIds = anno.classes.map(item => item.classId);
        } else {
          tmpAnno.words = anno.words;
          tmpAnno.cat = 0;
          tmpAnno.title = anno.words;
          tmpAnno.classIds = [];
        }
        return tmpAnno;
      });
      this.annos = JSON.parse(JSON.stringify(this.orgAnnos));
    },
    getNewImage() {
      this.wordsIndex = 0;
      let con = {};
      if (this.pageType !== 'edit') con = { page: this.pageType, taskId: this.$route.params.id };
      else con = { page: this.pageType, imageId: this.$route.params.imageid, taskId: this.$route.query.tid };
      api
        .getImage(con)
        .then(res => {
          this.showPanel = true;
          this.duoviewVisible = false;
          this.duoview = res.data.duoview ? { ...res.data.duoview, url: imageReformat(res.data.duoview.url) } : null;
          this.mode = 1;
          this.currClasses = [];
          this.sceneText = '';
          this.currAnno = {};
          this.imageId = res.data.id;
          this.url = res.data.url;
          this.orgUrl = this.url;
          this.height = res.data.height;
          this.width = res.data.width;
          this.annotations = res.data.annotations;
          this.imageStatus = res.data.imageStatus;
          if (this.pageType === 'edit') {
            if (res.data.taskTypeName) this.taskTypeName = res.data.taskTypeName;
            else {
              // this.taskTypeName = res.data.tasks.find(t => t.taskId == this.$route.query.tid).taskTypeName;
              // 暂时没法处理一张图在 多边形标注和矩形标注都有的情况下 添加标注的逻辑
              this.taskTypeName = res.data.tasks[0].taskTypeName;
            }
            this.taskType = this.taskTypeMap[this.taskTypeName];
            this.restImageCount = res.data.unApprovedCount;
            this.imageStatus = res.data.imageStatus;
            this.taskId = res.data.taskId;
            // 一张图片在多个任务中
            this.taskList = res.data.tasks;
            this.taskName = res.data.tasks[0].taskName;
            this.annotator = res.data.annotator;
            this.taskTypeId = (res.data.tasks[0] || {}).taskTypeId;
          } else if (this.pageType === 'approve') {
            this.taskTypeId = res.data.taskTypeId;
            this.taskType = this.taskTypeMap[this.taskTypeId];
            this.restImageCount = res.data.unApprovedCount;
          } else {
            this.taskTypeId = res.data.taskTypeId;
            this.taskType = this.taskTypeMap[this.taskTypeId];
          }
          this.annosFormat();
        })
        .catch(err => {
          window.console.log('error:', err);
          this.url = '';
          this.currAnno = {};
          this.currClasses = [];
          this.sceneText = '';
          this.annos = [];
        });
    },
    showDuoview() {
      this.duoviewVisible = true;
    },
    closeDuoview() {
      this.duoviewVisible = false;
    },
    finishImage() {
      if (this.annos.some(v => v.cat === undeterminedClassId)) {
        this.$message.error('存在待定类别未指定');
        return;
      }
      if (this.mode === 1) {
        this.showPanel = false;
        api
          .annotatedImage({ taskId: this.$route.params.id, imageid: this.imageId })
          .then(() => {
            this.annos = [];
            this.getNewImage();
            this.getTaskDetail();
          })
          .catch(() => {});
      }
    },
    invalidImage() {
      if (!window.confirm('确认图片中无标注目标，并将图片无效吗?')) return;
      this.mode = 1;
      let taskId = this.$route.params.id ? this.$route.params.id : this.taskId;
      api
        .invalidImage({
          pageType: this.pageType,
          imageid: this.imageId,
          taskId: taskId,
        })
        .then(() => {
          if (this.pageType === 'saapprove') {
            this.$notify({
              group: 'foo',
              text: '图片设置无效成功',
              type: 'custom-blue',
              duration: 1500,
            });
          } else this.getNewImage();
        })
        .catch(() => {});
    },
    newAnno() {
      this.$refs.annopanel.setPainter({
        type: this.taskTypeMap[this.taskTypeId ? this.taskTypeId : this.taskTypeName],
        data: [[]],
      });
      this.mode = 0;
    },
    saveVerification() {
      // 通用检测
      if (this.currAnno.data.some(v => v.some(v => Math.round(v[0]) > this.width || Math.round(v[1]) > this.height))) {
        this.$notify({
          group: 'foo',
          text: '有标注点无法保存，请删除',
          type: 'custom-red',
          duration: 1500,
        });
        return false;
      }

      // 类别选择检测(除了taskTypeId===5的)
      if (
        this.taskTypeId !== 5 &&
        this.taskTypeId !== 6 &&
        this.taskTypeName !== '文本多边形' &&
        this.taskTypeName !== '文本矩形'
      ) {
        if (!Object.keys(this.currClasses).length) {
          this.$notify({
            group: 'foo',
            text: '类别未选择完整',
            type: 'custom-red',
            duration: 1500,
          });
          return false;
        }
      } else {
        if (this.sceneText === '') {
          this.$notify({
            group: 'foo',
            text: '文本未填写',
            type: 'custom-red',
            duration: 1500,
          });
          return false;
        }
      }

      // 根据AnnoPanel组件里的标注类别判断 点数和最小面积
      if (this.currAnno.type === 3) {
        if (!this.currAnno.data.every(v => v.length > 2)) {
          this.$notify({
            group: 'foo',
            text: '多边形点数应不少于3，请确认',
            type: 'custom-red',
            duration: 1500,
          });
          return false;
        }
      } else if (this.currAnno.type === 2) {
        if (this.currAnno.data.some(v => Math.abs(v[0][0] - v[1][0]) * Math.abs(v[0][1] - v[1][1]) < 25)) {
          this.$notify({
            group: 'foo',
            text: '画框过小，请修改或删除',
            type: 'custom-red',
            duration: 1500,
          });
          return false;
        }
      }
      return true;
    },
    saveAnno() {
      if (this.role === 'admin' && this.currAnno.status === 4 && !window.confirm('确认修改申诉中标注吗?')) return;
      if (this.sceneText !== '') {
        this.sceneText = this.sceneText.replace(/\s+/g, ' ').trim();
      }
      this.currAnno = this.$refs.annopanel.getPainter();

      if (!this.saveVerification()) return;
      this.saveAnnoAble = true;
      // 如果是写字模式 需要更正anno的坐标
      if (this.currOperation === 'words') {
        // window.console.log('111:', this.currAnno.id);
        // window.console.log(this.orgAnnos);
        this.currAnno.data = JSON.parse(JSON.stringify(this.orgAnnos.find(v => v.id === this.currAnno.id).data));
      }
      if (!this.currAnno.id) {
        this.addAnno();
      } else {
        this.currAnno.data = this.currAnno.data.map(v => v.map(v => v.map(v => Math.round(v))));
        this.updateAnno();
      }
    },
    addAnno() {
      let anno = {
        pageType: this.pageType,
        taskId: this.$route.params.id ? this.$route.params.id : this.taskId,
        imageid: this.imageId,
        points: this.currAnno.data.map(v => v.map(v => v.map(v => Math.round(v)))),
        classIds: this.currClasses.filter(v => v),
      };
      if (!anno.taskId) {
        anno.taskId = (
          this.taskList.find(task => task.classes.map(v => v.classId).includes(anno.classIds[0])) || {}
        ).taskId;
      }
      if (
        this.taskTypeId === 5 ||
        this.taskTypeId === 6 ||
        this.taskTypeName === '文本矩形' ||
        this.taskTypeName === '文本多边形'
      )
        anno.words = this.sceneText;
      // 管理员处理申诉
      if (this.$route.query.aid) {
        anno.annotationId = this.$route.query.aid;
        api
          .saveAnno(anno)
          .then(res => {
            let tmpAnno = {
              id: res.data.id,
              type: this.currAnno.type,
              classIds: this.currClasses,
              data: this.currAnno.data,
              userId: this.$store.state.userId,
            };
            if (
              this.taskTypeId !== 5 &&
              this.taskTypeName !== '文本矩形' &&
              this.taskTypeId !== 6 &&
              this.taskTypeName !== '文本多边形'
            ) {
              tmpAnno.cat = this.currClasses[0];
              tmpAnno.title = this.currClasses.map(v => this.classes[v]).join(',');
            } else {
              tmpAnno.words = this.sceneText;
              tmpAnno.title = this.sceneText;
              tmpAnno.cat = 0;
            }
            if (this.pageType !== 'annotate') tmpAnno.status = 0;
            this.orgAnnos.push(tmpAnno);
            this.annos = JSON.parse(JSON.stringify(this.orgAnnos));
            this.mode = 1;
            this.currClasses = [];
            this.sceneText = '';
            this.currAnno = {};
            this.saveAnnoAble = false;
          })
          .catch(() => {
            this.saveAnnoAble = false;
          });
      } else
        api
          .addAnno(anno)
          .then(res => {
            let tmpAnno = {
              id: res.data.id,
              type: this.currAnno.type,
              classIds: this.currClasses,
              data: this.currAnno.data,
              userId: this.$store.state.userId,
            };
            if (
              this.taskTypeId !== 5 &&
              this.taskTypeName !== '文本矩形' &&
              this.taskTypeId !== 6 &&
              this.taskTypeName !== '文本多边形'
            ) {
              tmpAnno.cat = this.currClasses[0];
              tmpAnno.title = this.currClasses.map(v => this.classes[v]).join(',');
            } else {
              tmpAnno.words = this.sceneText;
              tmpAnno.title = this.sceneText;
              tmpAnno.cat = 0;
            }
            if (this.pageType !== 'annotate') tmpAnno.status = 0;
            this.orgAnnos.push(tmpAnno);
            this.annos = JSON.parse(JSON.stringify(this.orgAnnos));
            this.mode = 1;
            this.currClasses = [];
            this.sceneText = '';
            this.currAnno = {};
            this.saveAnnoAble = false;
          })
          .catch(() => {
            this.saveAnnoAble = false;
          });
    },
    updateAnno() {
      let anno = {
        taskId: this.$route.params.id || this.taskId,
        imageid: this.imageId,
        annotationId: this.currAnno.id,
        points: this.currAnno.data,
        classIds: this.currClasses,
        pageType: this.pageType,
      };
      if (
        this.taskTypeId === 5 ||
        this.taskTypeId === 6 ||
        this.taskTypeName === '文本矩形' ||
        this.taskTypeName === '文本多边形'
      )
        anno.words = this.sceneText;
      api
        .saveAnno(anno)
        .then(res => {
          // window.console.log(res);
          let tmpAnno = {
            id: res.data.id,
            type: this.currAnno.type,
            cat: this.currClasses[0],
            title: this.currClasses.map(v => this.classes[v]).join(','),
            classIds: this.currClasses,
            data: res.data.points,
            userId: this.$store.state.userId,
          };
          if (
            this.taskTypeId === 5 ||
            this.taskTypeId === 6 ||
            this.taskTypeName === '文本矩形' ||
            this.taskTypeName === '文本多边形'
          ) {
            tmpAnno.words = this.sceneText;
            tmpAnno.title = this.sceneText;
            tmpAnno.cat = 0;
          }
          // window.console.log('set过程1：', this.currAnno.id, JSON.parse(JSON.stringify(this.orgAnnos)));
          this.$set(
            this.orgAnnos,
            this.orgAnnos.findIndex(v => v.id === this.currAnno.id),
            tmpAnno,
          );
          // window.console.log('set过程2：', JSON.parse(JSON.stringify(this.orgAnnos)));
          if (this.currOperation !== 'words') {
            this.annos = JSON.parse(JSON.stringify(this.orgAnnos));
            this.mode = 1;
            this.sceneText = '';
            this.currClasses = [];
            this.currAnno = {};
          } else {
            this.nextAnno();
          }
          this.saveAnnoAble = false;
        })
        .catch(() => {
          this.saveAnnoAble = false;
        });
    },
    deleteAnno() {
      if (this.currOperation === 'words') {
        if (this.wordsIndex-- > 0) this.words();
        return;
      }
      this.currAnno = this.$refs.annopanel.getPainter();
      if (this.currAnno.id) {
        if (this.role === 'admin' && this.currAnno.status === 4 && !window.confirm('确认修改申诉中标注吗?')) return;
        api
          .deleteAnno({
            pageType: this.pageType,
            taskId: this.$route.params.id
              ? this.$route.params.id
              : this.taskId ||
                this.taskList.find(task => task.classes.map(v => v.classId).includes(this.currClasses[0])).taskId,
            imageid: this.imageId,
            annotationId: this.currAnno.id,
          })
          .then(() => {
            this.mode = 1;
            this.orgAnnos = this.orgAnnos.filter(v => v.id !== this.currAnno.id);
            this.annos = JSON.parse(JSON.stringify(this.orgAnnos));
            this.currClasses = [];
            this.sceneText = '';
            this.currAnno = {};
          })
          .catch(() => {});
      } else {
        this.mode = 1;
        this.currAnno = {};
        this.currClasses = [];
        this.sceneText = '';
      }
    },
    setClass(index, classId) {
      if (this.mode === 0) {
        this.$set(this.currClasses, index, classId);
      } else if (this.mode === 1 && this.pageType !== 'annotate') {
        if (!this.currClasses.find(v => v === classId)) {
          this.currClasses = [];
          this.sceneText = '';
          this.$set(this.currClasses, index, classId);
          this.annos = JSON.parse(JSON.stringify(this.orgAnnos.filter(v => v.classIds.includes(classId))));
        } else {
          this.currClasses = [];
          this.sceneText = '';
          this.annos = JSON.parse(JSON.stringify(this.orgAnnos));
        }
      }
    },
    annoClick: function(annoId) {
      // if (
      //   this.pageType !== 'annotate' ||
      //   this.annos.filter(v => v.id === annoId)[0].userId === this.$store.state.userId
      // ) {
      this.currAnno = this.annos.find(v => v.id === annoId);
      this.$refs.annopanel.setPainter(this.currAnno);
      this.currClasses = this.currAnno.classIds;
      if (
        this.taskTypeId === 5 ||
        this.taskTypeId === 6 ||
        this.taskTypeName === '文本矩形' ||
        this.taskTypeName === '文本多边形'
      ) {
        this.sceneText = this.currAnno.words;
        // this.wordsIndex = this.orgAnnos.findIndex(v => v.id === this.currAnno.id) + 1;
      }
      this.mode = 0;
      // }
    },
    rePaint() {
      this.currAnno = this.$refs.annopanel.getPainter();
      this.currAnno.data = [[]];
      this.$refs.annopanel.setPainter(this.currAnno);
    },
    // 获取任务信息，显示剩余审核图片数量
    getTaskDetail() {
      if (['approver', 'approverTwo'].includes(this.role)) {
        api.getTaskInfo({ taskId: this.$route.params.id }).then(res => {
          this.taskDetail = res.data.task;
        });
      }
    },
    reformatClassification() {
      // 如果超过一审，那么不需要在类别中添加待定类(针对taskType为7需要修改标注类别情况)
      if (this.imageStatus > 3) {
        this.classifications.forEach(classification => {
          classification.classes = classification.classes.filter(v => v.classId != undeterminedClassId);
        });
      }
    },
  },
};
